(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.editorSkinsData = f()}})(function(){var define,module,exports;
/* Autogenerated file. Do not modify */
'use strict';
var skins = {};
 skins['wysiwyg.viewer.skins.displayers.LinkBarItemNoBGSkin'] = {
  "react": [
    [
      "a",
      "link",
      [],
      {},
      [
        "div",
        "image",
        [],
        {}
      ]
    ]
  ],
  "exports": {
    "image": {
      "skin": "skins.core.ImageSkin"
    }
  },
  "css": {
    "%link": "cursor:pointer;"
  }
}
 skins['wysiwyg.viewer.skins.displayers.LinkBarItemSkin'] = {
  "react": [
    [
      "a",
      "link",
      [],
      {},
      [
        "span",
        "image",
        [],
        {}
      ]
    ]
  ],
  "exports": {
    "image": {
      "skin": "skins.core.ImageSkin"
    }
  },
  "params": {
    "bg": "BG_COLOR_ALPHA",
    "rd": "BORDER_RADIUS",
    "bgh": "BG_COLOR_ALPHA"
  },
  "paramsDefaults": {
    "bg": "color_11",
    "rd": "100%",
    "bgh": "color_11"
  },
  "css": {
    "%link": "cursor:pointer;",
    "%image": "z-index:10;",
    "%imageBG": "overflow:hidden;background-color:[bg];[rd]  position:relative !important;top:0;left:0;",
    "%imageBG:hover": "background-color:[bgh];"
  }
}
 skins['wysiwyg.viewer.skins.LinkBarNoBGSkin'] = {
  "react": [
    [
      "ul",
      "itemsContainer",
      [],
      {}
    ]
  ],
  "exports": {
    "imageItem": {
      "skin": "wysiwyg.viewer.skins.displayers.LinkBarItemNoBGSkin",
      "styleGroup": "displayer"
    }
  },
  "css": {
    "%[data-is-responsive~=\"false\"] %itemsContainer": "position:absolute;width:100%;height:100%;white-space:nowrap;",
    "%[data-is-responsive~=\"false\"][data-state~=\"mobileView\"] %itemsContainer": "position:absolute;width:100%;height:100%;white-space:normal;",
    "%[data-is-responsive~=\"true\"]": "display:table;",
    "%[data-is-responsive~=\"true\"] %itemsContainer": "display:-webkit-box;display:-webkit-flex;display:flex;",
    "%itemsContainer > li:last-child": "margin:0 !important;",
    "% a": "display:block;height:100%;"
  }
}

return skins;

});
